import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
 import Breadcrumb from "../components/Breadcrumb";
import WidgetGenerator from "../components/WidgetGenerator";

const GenerateWidgetPageLayer = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>
  {/* Breadcrumb */}
        <Breadcrumb title="Web Widget" />

        {/* TextGeneratorLayer */}
        <WidgetGenerator />

      </MasterLayout>

    </>
  );
};

export default GenerateWidgetPageLayer; 
